interface NzeroLogoProps {
  height?: number | string
  width?: number | string
}

export const NzeroLogo = ({
  height = "100%",
  width = "100%",
}: NzeroLogoProps) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    focusable="false"
    height={height}
    viewBox="0 0 731 227"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M286.52,99.21c0-48.36-71.98-56.69-122-56.69v28.35c-50.02,0-122,8.06-122,56.69s71.98,56.69,122,56.69v-28.35c50.02,0,122-8.06,122-56.69ZM164.52,155.91v-28.35c45.58,0,111.16-4.17,111.16-28.35s-65.31-28.35-111.16-28.35v28.35c-45.58,0-111.16,4.17-111.16,28.35s65.31,28.35,111.16,28.35Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M688.56,127.65c0,23.93-13.23,39.13-36.03,39.13s-36.03-15.2-36.03-39.13,13.79-39.13,36.03-39.13,36.03,15.2,36.03,39.13ZM675.61,127.65c0,17.74-8.16,29-23.08,29s-23.08-11.26-23.08-29,8.16-29,23.08-29,23.08,11.26,23.08,29Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M579.05,90.49h13.23v10.42h.84c1.13-1.97,2.53-4.22,4.5-5.91,1.97-1.97,4.5-3.38,7.6-4.5,3.38-1.13,7.88-1.41,12.95-.84v10.98c-5.07-.56-9.57,0-13.23,1.13-3.94,1.13-6.76,3.38-9.01,7.04-1.97,3.38-3.1,8.45-3.1,14.64v41.66h-13.51v-74.6h-.28Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M502.19,127.65c0-12.67,3.38-22.24,9.85-29,6.47-6.76,15.2-10.13,25.9-10.13s19.42,3.1,25.34,9.57c5.91,6.47,9.01,15.2,9.01,26.18v6.19h-57.15c0,8.16,1.97,14.64,6.19,19.42,4.22,4.79,9.85,7.04,16.89,7.04s8.16-.84,11.26-2.25c5.63-3.1,9.29-8.16,9.57-12.95h12.39c-.28,4.79-3.94,12.39-9.29,17.17-2.53,2.25-5.63,4.22-9.57,5.91-3.94,1.41-8.73,2.25-14.36,2.25-10.98,0-19.71-3.38-26.18-10.13-6.47-6.76-9.85-16.33-9.85-29h0v-.28ZM515.14,120.9h44.2c0-6.76-1.69-11.82-5.35-16.05s-9.01-6.19-16.05-6.19-12.39,1.97-16.33,6.19c-3.94,4.22-5.91,9.29-6.47,16.05Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M329.08,59.7h15.06l53.21,84.57h1.6V59.7h13.14v105.39h-15.06l-53.21-84.57h-1.6v84.57h-13.14V59.7Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M422.23,59.7h78.35v9l-62.87,85.79h64.48v10.6h-82.22v-9l62.87-85.79h-60.61v-10.6Z"
    />
  </svg>
)
